import BsBaseController from './_base_controller'
import Dropdown from 'bootstrap/js/src/dropdown'

// usage:
//   btn {
//     data-controller="bs--dropdown"
//   }
// through "_dropdown_btn" partial
export default class extends BsBaseController {
  _setAttributes() {
    super._setAttributes("dropdown")
  }

  _createBsComponent () {
    return new Dropdown(this.element)
  }
}
